import { ChiefBridge } from "../../libs/chief-bridge";

export interface NativeOutgoingMessage {
  [key: string]: unknown;
  Route_HomePage: never;
  startAppLoading: never;
  share: {
    title: string;
    shareContentText: string;
  };
  openLink: {
    linkType: number;
    linkUrl: string;
    aosLinkUrl?: string;
  };
}

export const bridge = new ChiefBridge<NativeOutgoingMessage>(
  "47th-activity-mainHall",
  true,
);
